exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select-container[data-v-8a9f1ece]{\n  display: flex;\n  gap: 15px;\n}\n.form-item__wrap[data-v-8a9f1ece] {\n  margin: 0px;\n  padding: 0px;\n  display: flex;\n  align-items: baseline;\n}\n", ""]);

// exports
